import { DATA_PAGE_UPLOAD_URL } from '../settings';
import { PagePayload } from '../types';
import fetchWithTimeout from '../utils/fetchWithTimeout';

class PageHandler {
  workspaceId: string;

  constructor(workspaceId: string) {
    this.workspaceId = workspaceId;
  }

  async upload(payload: PagePayload) {
    return fetchWithTimeout(DATA_PAGE_UPLOAD_URL, {
      method: 'POST',
      body: JSON.stringify({
        ...payload,
        workspaceId: this.workspaceId,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }
}

export default PageHandler;
